import Checkbox from '@material-ui/core/Checkbox';
import React, { useState } from "react";
import "../../sass/main.scss";
import './FormField.scss';
import unknown_release from "../../assets/images/unknown_release.svg";
import dont_release from "../../assets/images/dont_release.svg";
import { SensitiveInfoRelease } from '../../models/transaction';


export interface Item<TId extends number = number> {
    readonly id: TId;
    readonly label: string;
    readonly state: SensitiveInfoRelease;
}

interface CheckboxListProps<TId extends number = number> {
    items: readonly Item<TId>[],
    onChange?: (updatedItemId: TId, checked: boolean) => void,
    checkboxHeader: string,
    labelHeaders: readonly string[],
    className?: string,
    allowUncheck?: boolean,
    style?: React.CSSProperties,
    hasFreeText?: (item: Item<TId>) => boolean,
    freeText?: string,
    freeTextMaxLen?: number
    onChangeFreeText?: (text: string) => void,
}

/**
 * Component for setting information release.
 * 
 * @param props 
 * @returns 
 */
export function CheckboxList<TId extends number = number>(props: CheckboxListProps<TId>) {
    const items = props.items;
    const [freeText, setFreeText] = useState(props.freeText ?? "");

    const onChangeData = (checked: boolean, changedRow: Item<TId>) => {
        if (props.freeText && props.hasFreeText?.(changedRow) && !checked) {
            setFreeText("");
            props.onChangeFreeText?.("");
        }
        items.map(item => item.id == changedRow.id ? {
            ...item,
            state: checked ? SensitiveInfoRelease.Authorized : (props.allowUncheck ? SensitiveInfoRelease.NotMentioned : SensitiveInfoRelease.Prohibited),
        } : item);

        props.onChange?.(changedRow.id, checked);
    }

    const onBlurText = () => {
        if (freeText != (props.freeText ?? "")) {
            props.onChangeFreeText?.(freeText);
        }
    }

    return <table className={props.className} style={props.style}>
        <thead>
            <tr>
                <td>
                    {props.checkboxHeader}
                </td>
                {props.labelHeaders.map((h, i) => <td
                    key={`labelHeader${i}`}
                >
                    {h}
                </td>)}
                {props.hasFreeText && <td></td>}
            </tr>
        </thead>
        <tbody>
            {items.map((row, index) => <tr key={"row" + index}>
                <td>
                    <span>
                        <Checkbox
                            onChange={(e) => onChangeData(e.target.checked, row)}
                            checked={row.state == SensitiveInfoRelease.Authorized}
                            icon={<img src={row.state == SensitiveInfoRelease.Prohibited ? dont_release : unknown_release}/>}
                        />
                    </span>
                </td>
                <td>
                    {row.label}
                </td>
                {props.hasFreeText && <td>
                    {props.hasFreeText(row) && row.state == SensitiveInfoRelease.Authorized && <textarea
                        maxLength={props.freeTextMaxLen}
                        className="checkboxlist-text"
                        value={freeText}
                        onChange={e => setFreeText(e.currentTarget.value)}
                        onBlur={onBlurText}
                    />}
                </td>}
            </tr>)}
        </tbody>
    </table>
}

export default CheckboxList;

